import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomErrorHandlerService } from "../custom-error-handler.service";
import { ContactPreference } from "../../../models/contact-preference/contact-preference.model";
import { ContactPreferenceSerializer } from "../../../models/contact-preference/contact-preference-serializer.class";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable()
export class ContactPreferenceService extends BaseApiService<ContactPreference> {

  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      null,
      "contactpreferences",
      new ContactPreferenceSerializer(),
      new CustomErrorHandlerService()
    );
  }

  // Example of a method to get Contact Preferences by email
  getContactPreferencesByEmail(emailAddress: string): Observable<ContactPreference[]> {
    return this.httpClient
      .get<ContactPreference[]>(`${this.url}/by-email/${emailAddress}`)
      .pipe(
        map((data: any) => data.map((item: any): any => this.serializer.fromJson(item))),
        catchError(this.handleError)
      );
    }

    getContactPreferencesById(id: string): Observable<ContactPreference[]> {
        return this.httpClient
            .get<ContactPreference[]>(`${this.url}/by-id/${id}`)
            .pipe(
                map((data: any) => data.map((item: any): any => this.serializer.fromJson(item))),
                catchError(this.handleError)
            );
    }
}
